export const directLabsCheckout = {
  loading: "Loading checkout details",
  authStart: {
    title: "First, let's confirm that {{itemName}} is available in your area:",
    titleFallback: "First, let's confirm this lab is available in your area:",
    description: "Enter your email to sign in or create your Fullscript account.",
    emailLabel: "Email address",
    zipCodeLabel: "Zip code",
    locationNote: "Availability based on location",
    continueButton: "Continue",
    errors: {
      emailInvalid: "Please enter a valid email address",
      zipInvalid: "Please enter a valid zip code",
      generalError: "Something went wrong. Please try again.",
      recaptchaError: "reCAPTCHA verification failed. Please try again.",
    },
  },
  orderSummary: {
    title: "Order summary",
    testLabel: "Lab test",
    panelLabel: "Lab panel",
    panelTestCount: "Includes {{count}} lab test",
    panelTestCount_plural: "Includes {{count}} lab tests",
    subtotal: "Subtotal",
    taxesEstimated: "Taxes (est.)",
    taxesDeferred: "Calculated on next step",
    total: "Total",
  },
  // Blocked-state copy mirrors existing patient-facing lab messaging patterns
  // (patient `common.na` and the shared `labs.CannotOrderInState*` strings) —
  // deliberately not bespoke, per BUT-1109 scope.
  blocked: {
    unavailableLabel: "This item is not available.",
    stateRestrictedLabel: "Please contact your practitioner for next steps.",
  },
  // Waitlist copy mirrors the Journey checkout waitlist strings
  // (`journeyCheckout.waitlist`), reworded for a single lab item per BUT-1114
  // scope — same flow, no new waitlist semantics.
  waitlist: {
    title: "This item is not yet available in your state",
    description:
      "Join the waitlist now and we'll notify you when it becomes available in your area.",
    joinButton: "Join the waitlist",
    successToast:
      "You've been added to the waitlist! We'll notify you when this item becomes available in your area.",
    errorToast: "An error occurred while adding you to the waitlist. Please try again.",
  },
} as const;
